import { render, staticRenderFns } from "./event-docs.vue?vue&type=template&id=ae466a18"
import script from "./event-docs.vue?vue&type=script&lang=js"
export * from "./event-docs.vue?vue&type=script&lang=js"
import style0 from "./event-docs.vue?vue&type=style&index=0&id=ae466a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports